var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("toolbar", { attrs: { title: "User Profile" } }),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-layout",
            { staticClass: "mt-2", attrs: { column: "" } },
            [
              _c(
                "v-card",
                { staticClass: "py-3 pl-5" },
                [
                  _c(
                    "v-tabs",
                    { attrs: { color: "white", "show-arrows": "" } },
                    [
                      _c(
                        "v-tab",
                        { key: "contactInfo", attrs: { to: "#contact" } },
                        [_vm._v("\n            Contact Info\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-tab", { key: "bqa", attrs: { to: "#bqa" } }, [
                        _vm._v("\n            BQA Certificate\n          ")
                      ]),
                      _vm._v(" "),
                      _c("v-tab", { key: "cdlInfo", attrs: { to: "#cdl" } }, [
                        _vm._v("\n            CDL Info\n          ")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        [
                          _c(
                            "v-tab-item",
                            { attrs: { value: "contact", lazy: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "align-baseline": "" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "title mr-3 py-4" },
                                    [
                                      _vm._v(
                                        "\n                  Contact info\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { column: "", sm6: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-5",
                                          attrs: { sm3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              readonly: _vm.isNonceUser,
                                              label: "Full Name"
                                            },
                                            model: {
                                              value: _vm.name,
                                              callback: function($$v) {
                                                _vm.name = $$v
                                              },
                                              expression: "name"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-5",
                                          attrs: { sm3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              disabled: "",
                                              label: "Account Email"
                                            },
                                            model: {
                                              value: _vm.contactEmail,
                                              callback: function($$v) {
                                                _vm.contactEmail = $$v
                                              },
                                              expression: "contactEmail"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-5",
                                          attrs: { sm3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              readonly: _vm.isNonceUser,
                                              label: "Contact Phone"
                                            },
                                            model: {
                                              value: _vm.contactPhone,
                                              callback: function($$v) {
                                                _vm.contactPhone = $$v
                                              },
                                              expression: "contactPhone"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "mr-5",
                                          attrs: { sm4: "" }
                                        },
                                        [
                                          _c("v-textarea", {
                                            attrs: {
                                              readonly: _vm.isNonceUser,
                                              label: "Brief Bio"
                                            },
                                            model: {
                                              value: _vm.briefBio,
                                              callback: function($$v) {
                                                _vm.briefBio = $$v
                                              },
                                              expression: "briefBio"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.isNonceUser
                                    ? _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "accent",
                                                  attrs: {
                                                    loading: _vm.loadingBtn
                                                  },
                                                  on: {
                                                    click: _vm.saveContactInfo
                                                  }
                                                },
                                                [_vm._v("Save")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { attrs: { value: "bqa", lazy: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "align-baseline": "" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "title mr-3 py-4" },
                                    [
                                      _vm._v("\n                  BQA  "),
                                      _c("bqa-certificate-icon", {
                                        attrs: { driver: _vm.userInfo }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "pl-2 mr5",
                                    attrs: { sm3: "" }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { sm6: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: { label: "BQA Id" },
                                            model: {
                                              value: _vm.bqaId,
                                              callback: function($$v) {
                                                _vm.bqaId = $$v
                                              },
                                              expression: "bqaId"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("upload-button", {
                                            staticClass: "cursor-pointer",
                                            attrs: { label: "Certificate" },
                                            on: { files: _vm.bpaFileUpload },
                                            model: {
                                              value: _vm.bqaFile,
                                              callback: function($$v) {
                                                _vm.bqaFile = $$v
                                              },
                                              expression: "bqaFile"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-menu",
                                            {
                                              ref: "bqaExpiresDateMenu",
                                              attrs: {
                                                "close-on-content-click": false,
                                                "nudge-right": 40,
                                                "return-value": _vm.expires,
                                                lazy: "",
                                                transition: "scale-transition",
                                                "offset-y": "",
                                                "full-width": "",
                                                disabled: _vm.isNonceUser,
                                                "min-width": "290px"
                                              },
                                              on: {
                                                "update:returnValue": function(
                                                  $event
                                                ) {
                                                  _vm.expires = $event
                                                },
                                                "update:return-value": function(
                                                  $event
                                                ) {
                                                  _vm.expires = $event
                                                }
                                              },
                                              model: {
                                                value: _vm.bqaExpiresDateMenu,
                                                callback: function($$v) {
                                                  _vm.bqaExpiresDateMenu = $$v
                                                },
                                                expression: "bqaExpiresDateMenu"
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  slot: "activator",
                                                  label: "BQA Expires",
                                                  "prepend-icon": "event",
                                                  readonly: ""
                                                },
                                                slot: "activator",
                                                model: {
                                                  value: _vm.expires,
                                                  callback: function($$v) {
                                                    _vm.expires = $$v
                                                  },
                                                  expression: "expires"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "v-date-picker",
                                                {
                                                  attrs: {
                                                    "no-title": "",
                                                    scrollable: ""
                                                  },
                                                  model: {
                                                    value: _vm.expires,
                                                    callback: function($$v) {
                                                      _vm.expires = $$v
                                                    },
                                                    expression: "expires"
                                                  }
                                                },
                                                [
                                                  _c("v-spacer"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.bqaExpiresDateMenu = false
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("Cancel")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        color: "primary"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.$refs.bqaExpiresDateMenu.save(
                                                            _vm.expires
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          OK\n                        "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.documentUri
                                            ? _c(
                                                "v-btn",
                                                {
                                                  attrs: { flat: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openBqaCertificate()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Open certificate\n                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.isNonceUser
                                    ? _c(
                                        "v-layout",
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "mr-5",
                                              attrs: { sm3: "" }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "accent",
                                                  attrs: {
                                                    disabled:
                                                      !_vm.bqaFileData ||
                                                      !_vm.expires,
                                                    loading: _vm.loadingBtn
                                                  },
                                                  on: { click: _vm.saveBQA }
                                                },
                                                [_vm._v("Save")]
                                              ),
                                              _vm._v(" "),
                                              _vm.isLtnAdmin && !_vm.verified
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-3",
                                                      attrs: {
                                                        color: "primary",
                                                        disabled: !_vm.expires,
                                                        loading: _vm.loadingBtn
                                                      },
                                                      on: {
                                                        click: _vm.verifyBqa
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      Verify\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            { attrs: { value: "cdl", lazy: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { "align-baseline": "" } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "title mr-3 py-4" },
                                    [
                                      _vm._v(
                                        "\n                  CDL Info\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  !_vm.isNonceUser
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "pl-2 mr5",
                                          attrs: { sm3: "" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Add your CDL information to your Profile so loads can be assigned to you.\n                "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showDriverProfileSection
                                ? _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { column: "", sm6: "" } },
                                        [
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "mr-5",
                                                  attrs: { sm3: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      ref: "cdlExpiresDateMenu",
                                                      attrs: {
                                                        "close-on-content-click": false,
                                                        "nudge-right": 40,
                                                        "return-value":
                                                          _vm.cdlExpires,
                                                        lazy: "",
                                                        transition:
                                                          "scale-transition",
                                                        "offset-y": "",
                                                        "full-width": "",
                                                        disabled:
                                                          _vm.isNonceUser,
                                                        "min-width": "290px"
                                                      },
                                                      on: {
                                                        "update:returnValue": function(
                                                          $event
                                                        ) {
                                                          _vm.cdlExpires = $event
                                                        },
                                                        "update:return-value": function(
                                                          $event
                                                        ) {
                                                          _vm.cdlExpires = $event
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.cdlExpiresDateMenu,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.cdlExpiresDateMenu = $$v
                                                        },
                                                        expression:
                                                          "cdlExpiresDateMenu"
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          slot: "activator",
                                                          label: "CDL Expires",
                                                          "prepend-icon":
                                                            "event",
                                                          readonly: ""
                                                        },
                                                        slot: "activator",
                                                        model: {
                                                          value: _vm.cdlExpires,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.cdlExpires = $$v
                                                          },
                                                          expression:
                                                            "cdlExpires"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-date-picker",
                                                        {
                                                          attrs: {
                                                            "no-title": "",
                                                            scrollable: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.cdlExpires,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.cdlExpires = $$v
                                                            },
                                                            expression:
                                                              "cdlExpires"
                                                          }
                                                        },
                                                        [
                                                          _c("v-spacer"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.cdlExpiresDateMenu = false
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Cancel")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.$refs.cdlExpiresDateMenu.save(
                                                                    _vm.cdlExpires
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            OK\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  staticClass: "mr-5",
                                                  attrs: { sm3: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-menu",
                                                    {
                                                      ref:
                                                        "medicalExpiresDateMenu",
                                                      attrs: {
                                                        "close-on-content-click": false,
                                                        "nudge-right": 40,
                                                        "return-value":
                                                          _vm.medicalExpires,
                                                        lazy: "",
                                                        transition:
                                                          "scale-transition",
                                                        "offset-y": "",
                                                        "full-width": "",
                                                        disabled:
                                                          _vm.isNonceUser,
                                                        "min-width": "290px"
                                                      },
                                                      on: {
                                                        "update:returnValue": function(
                                                          $event
                                                        ) {
                                                          _vm.medicalExpires = $event
                                                        },
                                                        "update:return-value": function(
                                                          $event
                                                        ) {
                                                          _vm.medicalExpires = $event
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.medicalExpiresDateMenu,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.medicalExpiresDateMenu = $$v
                                                        },
                                                        expression:
                                                          "medicalExpiresDateMenu"
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          slot: "activator",
                                                          label:
                                                            "Medical Expires",
                                                          "prepend-icon":
                                                            "event",
                                                          readonly: ""
                                                        },
                                                        slot: "activator",
                                                        model: {
                                                          value:
                                                            _vm.medicalExpires,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.medicalExpires = $$v
                                                          },
                                                          expression:
                                                            "medicalExpires"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-date-picker",
                                                        {
                                                          attrs: {
                                                            "no-title": "",
                                                            scrollable: ""
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.medicalExpires,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.medicalExpires = $$v
                                                            },
                                                            expression:
                                                              "medicalExpires"
                                                          }
                                                        },
                                                        [
                                                          _c("v-spacer"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  _vm.medicalExpiresDateMenu = false
                                                                }
                                                              }
                                                            },
                                                            [_vm._v("Cancel")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                flat: "",
                                                                color: "primary"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.$refs.medicalExpiresDateMenu.save(
                                                                    _vm.medicalExpires
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            OK\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !_vm.isNonceUser
                                            ? _c(
                                                "v-layout",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      staticClass: "mr-5",
                                                      attrs: { sm3: "" }
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          staticClass: "accent",
                                                          attrs: {
                                                            loading:
                                                              _vm.loadingBtn
                                                          },
                                                          on: {
                                                            click: _vm.saveCDL
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Save\n                      "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _c(
                                    "v-layout",
                                    [
                                      !_vm.isNonceUser
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "accent",
                                              on: {
                                                click: function($event) {
                                                  _vm.showDriverProfile = true
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { staticClass: "mr-2" },
                                                [_vm._v("add_circle")]
                                              ),
                                              _vm._v(
                                                "\n                  Add CDL Details\n                "
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.userProfile.companyAccounts &&
          _vm.userProfile.companyAccounts.length
            ? _c(
                "v-layout",
                { staticClass: "mt-2", attrs: { column: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pt-2 pb-4 pl-5 pr-5 mt-3" },
                    [
                      _c("v-layout", { attrs: { "align-baseline": "" } }, [
                        _c("div", { staticClass: "title mr-3 mt-4 py-4" }, [
                          _vm._v(
                            "\n            Company Permissions\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { column: "", sm6: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { column: "" } },
                            [
                              _c(
                                "v-layout",
                                { staticClass: "mt-3", attrs: { column: "" } },
                                [
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "secondary--text",
                                          attrs: { sm2: "" }
                                        },
                                        [_vm._v("Company")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "secondary--text",
                                          attrs: { sm2: "" }
                                        },
                                        [_vm._v("Phone")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "secondary--text",
                                          attrs: { sm2: "" }
                                        },
                                        [_vm._v("Email")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          staticClass: "secondary--text",
                                          attrs: { sm3: "" }
                                        },
                                        [_vm._v("Permissions")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", { staticClass: "my-1" }),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.userProfile.companyAccounts,
                                    function(companyAccount, index) {
                                      return [
                                        _c(
                                          "v-layout",
                                          { key: index },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                staticClass: "cursor-pointer",
                                                attrs: { sm2: "" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.viewCompanyProfile(
                                                      companyAccount.companyId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      companyAccount.companyDisplayName
                                                    )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { sm3: "" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    companyAccount.contactPhone
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { sm3: "" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    companyAccount.contactEmail
                                                  ) + " "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { sm3: "" } },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      companyAccount.companyPermissions
                                                        ? companyAccount.companyPermissions.join(
                                                            ", "
                                                          )
                                                        : null
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-divider", {
                                          key: "div_" + index,
                                          staticClass: "my-1"
                                        })
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36e7d769", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e7d769","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User/Profile.vue
// module id = null
// module chunks = 